export var selectHandler = function selectHandler(tabId, onChange, includeAll) {
  return function () {
    var condition = includeAll ? tabId : tabId === 'all' ? null : tabId;
    onChange(condition);
  };
};
export var setAsChecked = function setAsChecked(tabId, selectedValue, includeAll) {
  var condition = includeAll ? tabId === selectedValue : tabId === selectedValue || tabId === 'all' && selectedValue === '';
  return condition;
};